module.exports = __webpack_public_path__ + "27cb4dc188f7ed9002ee9a39c5f4cd0b.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/union.svg
// module id = 943
// module chunks = 0